import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  output
} from '@angular/core';
import { Chip } from 'primeng/chip';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-chip',
  templateUrl: './m-chip.component.html',
  imports: [Chip]
})
export class MChipComponent implements OnInit {
  @Input() label: string | undefined;
  @Input() icon: string | undefined;
  @Input() removable = false;
  @Input() disabled = false;
  @Input() value: string | null = null;
  @Input() textStyleClass = 'b2';
  @Input() style: Record<string, unknown> | null | undefined;
  @Input() styleClass: string | undefined;
  readonly remove = output<string | null>();

  disabledTokens = {
    root: { background: 'var(--m-gray-100)', color: 'var(--m-gray-600)' },
    icon: { color: 'var(--m-gray-600)' }
  };

  ngOnInit() {
    this.value = this.value || this.label || null;
  }

  removeChip() {
    if (!this.disabled) {
      this.remove.emit(this.label || this.value);
    }
  }
}
